import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function TripRoad({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>TripRoad</title>
      <path
        d="M15 9.05128C15 10.0426 15.814 10.8462 16.8182 10.8462L18.5065 10.8462C19.5824 10.8462 20.4545 9.98516 20.4545 8.92308C20.4545 7.86099 19.5824 7 18.5065 7L16.9481 7C15.8722 7 15 6.13901 15 5.07692C15 4.01484 15.8722 3.15385 16.9481 3.15385L18.6364 3.15385C19.6405 3.15385 20.4545 3.95744 20.4545 4.94872M17.7273 2L17.7273 3.15385M17.7273 10.8462L17.7273 12"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 22.5L8 10"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 22.5L18 16.25"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 22.5V21.25"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 17.5V16.25"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 12.5V11.25"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
